import { connectTradeDone } from '../status/trade.done.connect';
import { AddOnQuoteActionComponent } from './AddonQuoteAction';
import { connectAddonQuoteAction } from './AddonQuoteAction.connect';
import { Component as TradeConfirmationComponent } from './tradeConfirmation';
import { connectTradeAction } from './tradeConfirmation.connect';
import { TradeDoneButton } from './tradeDone';

export const AddonQuoteAction = connectAddonQuoteAction(AddOnQuoteActionComponent);
AddonQuoteAction.displayName = 'AddonQuoteAction';
export const TradeActions = connectTradeAction(TradeConfirmationComponent);
TradeActions.displayName = 'TradeConfirmation';

export const TradeDone = connectTradeDone(TradeDoneButton);
TradeDone.displayName = 'TradeDone';
